// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"24eb0bdc","389":"0feebc91"}[chunkId] + ".chunk.js";
};